import React from 'react';
import { LinearProgress, linearProgressClasses, LinearProgressProps } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';

const rainbowGradient = keyframes`
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 200% 50%;
  }
`;

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: 8,
  borderRadius: 999,
  backgroundColor: theme.palette.action.hover,

  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 999,
    backgroundImage: 'linear-gradient(90deg, #FF1744, #FF9100, #FFEA00, #00E676, #2979FF, #651FFF, #FF1744)',
    backgroundSize: '200% 100%',
    animation: `${rainbowGradient} 4s linear infinite`,
  },
}));

export default function RainbowLinearProgress(props: LinearProgressProps) {
  return <StyledLinearProgress {...props} />;
}
